<template>
  <div class="container">
    <b-modal
      :model-value="modInfoUser"
      :no-close-on-backdrop="true"
      hide-footer
      hide-header-close
      centered
      :title="labels.title"
      header-class="reset-modal-header"
      title-class="reset-modal-title"
      body-class="reset-modal-body"
      class="reset-password-dialog"
    >
        <div class="uniform-modal-body">
            <div class="password-policy-box mb-3">
                <div class="password-policy-title">{{ labels.infoTitle }}</div>
                <div class="password-policy-item">{{ labels.infoText }}</div>
            </div>
            <b-row>
                <b-col>
                    <h5>{{labels.name}}</h5> 
                </b-col>
                <b-col>
                    <h6>{{dataUser[0]?.nombre}}</h6> 
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <h5>{{labels.cedula}}</h5> 
                </b-col>
                <b-col>
                    <h6>{{dataUser[0]?.cedula}}</h6> 
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <h5>{{labels.correo}}</h5> 
                </b-col>
                <b-col>
                    <h6>{{dataUser[0]?.email}}</h6> 
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <h5>{{labels.phone}}</h5> 
                </b-col>
                <b-col>
                    <h6>{{dataUser[0]?.telefono}}</h6> 
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <h5>{{labels.rol}}</h5> 
                </b-col>
                <b-col>
                    <!-- <h5>{{dataUser?.name}}</h5> --> 
                    {{ nombreRol() }}
                </b-col>
            </b-row>
            <div class="reset-dialog-actions d-flex justify-content-end mt-3 uniform-actions-wrap">
                <b-button class="reset-btn-secondary" @click="cierraModal">{{ labels.close }}</b-button>
            </div>
        </div>
    </b-modal>
  </div>
</template>

<script>
export default {
    name: 'infoUser',
    props: ['modInfoUser','dataRole','dataUser'],
    data: () => ({

    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") { 
                return {
                    title : "Información del Usuario",
                    save : "Guardar",
                    close : "Cerrar",
                    name : "Nombre:",
                    cedula : "Cedula:",
                    correo : "Correo electrónico:",
                    phone : "Telefono:",
                    rol : "Rol:",
                    infoTitle: "Datos del usuario",
                    infoText: "Consulta la información del usuario."
                }
            }else{
                return {
                    title : "User information",
                    save : "Save",
                    close : "Close",
                    name : "Name:",
                    cedula : "Identification number:",
                    correo : "Email:",
                    phone : "Phone:",
                    rol : "Rol:",
                    infoTitle: "User information",
                    infoText: "Review the user information."
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false) 
        },
        nombreRol(){
            let nameRole = ''
            this.dataUser.forEach((user) => { 
                // console.log(user) 
                this.dataRole.forEach((rol) => { 
                    // console.log(rol) 
                    if(rol.id == user.id_rol){ 
                        // console.log(rol.nombre) 
                        nameRole = rol.nombre 
                    }
                })
            })
            return nameRole
        }
    }
}
</script>

<style>

</style>
